import React from "react";
import ProjectWorkspacePage from "./ProjectWorkspacePage";

// This route (/admin/projects/:projectId) used to redirect straight into
// the inline Project Detail workspace merged into Project Management
// (/admin/projects?project=..&tab=..) -- see the git history of this file
// for that redirect shim. It now renders the full Project-Type-Driven
// Project Workspace directly: header + Overview/Process/Board/Timeline/
// Milestones/Activity tabs, all driven by the project's Project Type (see
// ProjectWorkspacePage.jsx and the other ProjectWorkspace*.jsx files in
// this folder). Kept as its own file (rather than pointing the route at
// ProjectWorkspacePage directly in AppRoutes.js) so this route's intent --
// "the standalone project detail page" -- stays documented at the route's
// own component instead of only in a routing table comment.
//
// The inline Members/Modules management panel on /admin/projects itself is
// untouched and unaffected by this change -- ProjectWorkspaceHeader links
// back into it ("Manage Members & Modules") rather than duplicating it here.
export default function ProjectDetailPage() {
  return <ProjectWorkspacePage />;
}
